export default {
  'grid-lg-2': {
    maxWidth: '20%',
    flexBasis: '20%',
  },
};
